import React from 'react';
import { Facebook, Instagram, Linkedin, Phone, Mail } from 'lucide-react';
import { AGENT, BAYLEYS_LOGO } from '@/data/agent';
import { LANDING } from '@/constants/testIds';

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid={LANDING.footer}
      className="bg-[#001833] text-white"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-14 lg:py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        {/* Brand */}
        <div className="md:col-span-5">
          <img
            src={BAYLEYS_LOGO}
            alt="Bayleys — Altogether Better"
            className="h-10 w-auto"
          />
          <p className="mt-6 text-sm text-white/65 leading-relaxed max-w-sm">
            {AGENT.office.legal}
            <br />
            {AGENT.office.licence}
          </p>
        </div>

        {/* Contact */}
        <div className="md:col-span-4 space-y-3">
          <p className="text-xs tracking-[0.3em] uppercase text-white/45 mb-4">
            Kaid Maycock
          </p>
          <a
            href={AGENT.phoneHref}
            className="flex items-center gap-3 text-sm text-white/85 hover:text-bayleys-gold transition-colors"
          >
            <Phone className="w-4 h-4 text-white/45" />
            {AGENT.phone}
          </a>
          <a
            href={AGENT.emailHref}
            className="flex items-center gap-3 text-sm text-white/85 hover:text-bayleys-gold transition-colors break-all"
          >
            <Mail className="w-4 h-4 text-white/45 shrink-0" />
            {AGENT.email}
          </a>
        </div>

        {/* Office + Socials */}
        <div className="md:col-span-3">
          <p className="text-xs tracking-[0.3em] uppercase text-white/45 mb-4">
            Office — {AGENT.office.name}
          </p>
          <p className="text-sm text-white/75 leading-relaxed">
            {AGENT.office.address}
          </p>
          <a
            href={AGENT.office.phoneHref}
            className="block mt-2 text-sm text-white/75 hover:text-bayleys-gold transition-colors"
          >
            {AGENT.office.phone}
          </a>

          <div className="mt-6 flex items-center gap-3">
            <a
              data-testid={LANDING.footerFacebook}
              href={AGENT.socials.facebook}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
              className="flex items-center justify-center w-9 h-9 border border-white/15 hover:border-bayleys-gold hover:text-bayleys-gold transition-colors"
            >
              <Facebook className="w-4 h-4" />
            </a>
            <a
              data-testid={LANDING.footerInstagram}
              href={AGENT.socials.instagram}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              className="flex items-center justify-center w-9 h-9 border border-white/15 hover:border-bayleys-gold hover:text-bayleys-gold transition-colors"
            >
              <Instagram className="w-4 h-4" />
            </a>
            <a
              data-testid={LANDING.footerLinkedin}
              href={AGENT.socials.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
              className="flex items-center justify-center w-9 h-9 border border-white/15 hover:border-bayleys-gold hover:text-bayleys-gold transition-colors"
            >
              <Linkedin className="w-4 h-4" />
            </a>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/45">
          <p>© {year} Kaid Maycock. All rights reserved.</p>
          <p className="tracking-wider uppercase">Bayleys — Altogether Better</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
